/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.calendar.days'},
});

const DaysItem = () => (
  <RouteLinkItem route="midas/settings/calendar/days" title={messages.title} />
);

export default DaysItem;
